<div class="fcp-empty-state">
    <div class="fcp-empty-state-image">
        <img [src]="imageSrc" alt="Empty State" />
    </div>
    <div class="fcp-empty-state-header">
        <p>{{ header }}</p>
    </div>

    <div class="fcp-empty-state-description">
        <ng-content select="[fcpEmptyStateDescription]"></ng-content>
    </div>

    <div class="fcp-empty-state-actions">
        <ng-content select="[fcpEmptyStateActions]"></ng-content>
    </div>
</div>
